import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import CommentsList from "./Comments";
import AddCommentForm from "./AddComment";
import { NotificationProvider } from "../helpers/NotificationContext";

const CommentsSection = ({ t_controls, user, event_id, player_id }) => {
  const [comments, setComments] = useState([]);
  const [playersList, setPlayersList] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  // Set the default tab based on the page - if on player page, force privateTab to true
  const [privateTab, setPrivateTab] = useState(!!player_id);

  // Check if admin has associated player
  const hasAssociatedPlayer = user?.admin ? !!user.player_id : true;

  // Check if this is the user's own player page
  const isOwnPlayerPage = !!player_id && user?.id === player_id;

  // Create a memoized getComments function
  const getComments = useCallback(() => {
    if (!user) return;

    const token = document.querySelector("[name=csrf-token]")?.content;
    const locale = window.location.pathname.split("/")[1];
    const base = `/${locale}`;
    let request = event_id ? `${base}/comments?event_id=${event_id}` : (player_id ? `${base}/comments?player_id=${player_id}` : `${base}/comments`);

    axios
      .get(
        request,
        {
          headers: {
            "X-CSRF-TOKEN": token,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setComments(response.data.comments);
        setPlayersList(response.data.players_list);
      })
      .catch((error) => {
        console.error("Failed to load comments:", error);
      });
  }, [event_id, player_id, user]);

  // Use refreshTrigger to force refresh after edits and deletes
  useEffect(() => {
    getComments();
  }, [getComments, refreshTrigger]);

  const handleCommentsChange = (updatedComments) => {
    setComments(updatedComments);
    // Trigger a refresh when comments change via delete
    setRefreshTrigger(prev => prev + 1);
  };

  // Custom privateTab setter to prevent changing to public tab on player pages
  const handleSetPrivateTab = (value) => {
    // Only allow changing to public tab if on game page (event_id exists)
    if (player_id && !value) {
      return; // Prevent changing to public tab on player page
    }
    setPrivateTab(value);
  };

  // If it's the user's own player page, only show the comments list without the comment form
  // const shouldShowCommentForm = !isOwnPlayerPage && (!user.admin || hasAssociatedPlayer);
  // Allow showing the form on own player page, just check admin status
  const shouldShowCommentForm = (!user?.admin || hasAssociatedPlayer);

  return (
    <NotificationProvider>
      {user && (
        <>
          <CommentsList
            comments={comments}
            user={user}
            player_id={player_id}
            playersList={playersList}
            t_controls={t_controls}
            onCommentsChange={handleCommentsChange}
            privateTab={privateTab}
            setPrivateTab={handleSetPrivateTab}
            isPlayerPage={!!player_id}
            event_id={event_id}
          />

          {/* Only show AddCommentForm if not on own player page and (not an admin or admin has an associated player) */}
          {shouldShowCommentForm && (
            <AddCommentForm
              user={user}
              player_id={player_id}
              event_id={event_id}
              playersList={playersList}
              setComms={setComments}
              t_controls={t_controls}
              privateTab={privateTab}
              setRefreshTrigger={setRefreshTrigger}
              isPlayerPage={!!player_id}
            />
          )}
        </>
      )}
    </NotificationProvider>
  );
};

export default CommentsSection;
